import { useState } from 'react'
import styles from './StatementForm.module.scss'

import RaportForm from './components/RaportForm/RaportForm'

import userInfo from 'utils/userInfo'

function StatementForm({ setRender, setState }) {


  const user = userInfo()
 
  return (
    <div className={styles.statement_wrapper}>
      <div className={styles.statement_body}>
        <RaportForm
          userId={user.employeeId}
          setRender={setRender}
          setState={setState}
        />
      </div>
    </div>
  )
}

export default StatementForm
